import { useEffect } from 'react';

export default function useBrokerTheme(theme: string | undefined) {
  useEffect(() => {
    if (!theme) {
      document.documentElement.removeAttribute('data-theme');

      return;
    }

    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);
}
